import global from '../patterns/global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import './vendor/jquery.additional-methods.min.js';
import utils from '../patterns/utils';

export default () => {
  $('#unsubscribe-form').validate({
    rules: {
      'unsubCheck': {
        required: true
      },

      'email': {
        required: true,
        pattern: '^(([0-9a-zA-Z])+([-._\\\'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$',
      },
    },
    showErrors: function (errorMap, errorList) {
      this.successList.forEach((e) => {
        const targetName = e.name;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error`);

        targetElements.removeClass('error');
        errorElement.addClass('hidden');
      });

      errorList.forEach((error) => {
        const targetName = error.element.name;
        const {method} = error;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-label .form-error`);

        targetElements.addClass('error');
        errorElement.removeClass('hidden');

        targetElements.attr('aria-invalid', 'true');
      });
    },
    submitHandler: function (form) {
      //Submit the form

      const postData = { 'anonymousToken': utils.getAnonymousToken() };
      //Build post body
      $('input', form).each((i, el)=> {
        if (el.name == 'unsubCheck') {
          postData[el.value] = el.checked;
        } else if(el.name) {
          postData[el.name] = el.value;
        }
      });

      utils.setButtonLoadingState('#submit-unsubscribe', '#unsubscribe-loading', true);

      $.ajax(global.API_ENDPOINT() + '/unsubscribe', {
        data: JSON.stringify(postData),
        dataType: 'json',
        method: 'POST',
        xhrFields: {
          withCredentials: true,
        }
      })
        .done(function (resp) {
          if (resp.success) {
            window.dataLayer.push({ 'event': 'Form_Success', 'Form_Name': 'Unsubscribe', });
            window.location.href = "/unsubscribe-confirmation";
          } else {
            console.error(JSON.stringify(resp));
            utils.setButtonLoadingState('#submit-unsubscribe', '#unsubscribe-loading', false);
            window.location.href = '/server-error';
          }
        })
        .fail(function (err) {
          console.error(JSON.stringify(err));
          utils.setButtonLoadingState('#submit-unsubscribe', '#unsubscribe-loading', false);
          window.location.href = '/server-error';
        })
    },
  });
  
};